<template>
  <div class="card mb-3 w-100" :class="!embedded && 'shadow'">
    <div class="row g-0">
      <label class="col-md-3">
        <a :href="link" class="d-flex justify-content-center rounded-start h-100 p-1">
          <div v-if="image" class="w-100" :style="'background: url(' + image + ') no-repeat center / contain;'"></div>
        </a>
      </label>
      <div class="col-md-9">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <a :href="link" class="link-primary h4 mb-0 text-decoration-none text-break">
              {{ title }}
            </a>
            <div class="dropdown dropend ms-3">
              <button
                class="btn border text-muted hover:text-secondary"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bi bi-three-dots"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end dropdown-menu-lg-start shadow">
                <li class="dropdown-item cursor-pointer">
                  <a :href="link" class="text-dark text-decoration-none">
                    <i class="bi bi-pencil-fill"></i> bearbeiten
                  </a>
                </li>
                <li v-if="id" class="dropdown-item cursor-pointer" @click="$emit('removeItem', id)">
                  <i class="bi bi-trash"></i>
                  löschen
                </li>
                <li v-if="id" class="dropdown-item cursor-pointer" @click="$emit('copyItem', id)">
                  <base-icon-copy id="copy-icon"></base-icon-copy>
                  kopieren
                </li>
              </ul>
            </div>
          </div>
          <p class="card-text">
            {{ description }}
            <small v-if="updatedAt" class="d-block text-muted mt-3">
              Zuletzt bearbeitet am: <strong>{{ updatedAt }}</strong>
            </small>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: 'Kein Titel vorhanden',
    },
    description: {
      type: String,
      default: 'Kein Untertitel vorhanden',
    },
    updatedAt: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: 'https://via.placeholder.com/320x240',
    },
    alt: {
      type: String,
      default: 'Ihr Alt-Tag',
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['removeItem'],
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#copy-icon {
  width: 24px;
  height: auto;
}
</style>
